<template>
    <div class="m-2">
        <div class="border-b border-gray-400 ml-2 mr-2 pb-2">
            <div class="text-gray-800">{{ $t('component.excluded.title') }}</div>
        </div>

        <div v-if="loading" class="flex justify-center ">
            <LoadingSpinner></LoadingSpinner>
        </div>
        <div v-else>
            <div class="mt-2">
                <div v-if="excludes.length === 0">
                    <div class="mt-5 mx-3 text-sm py-4 text-center">{{ $t('component.excluded.no_exclusions') }}</div>
                </div>
                <div v-else>
                    <CardBase v-for="exclude in excludes" :key="exclude.customer_id" class="shadow cursor-pointer">
                        <div class="px-2 py-1 flex justify-between bg-white">
                            <div class="flex">
                                <div class="pt-1 font-bold text-sm ml-2">{{  exclude.customer_id }}</div>
                            </div>
                        </div>
                        <div class="bg-white">
                            <ul class="text-sm ml-4 mb-1">
                                <li>{{ $t('component.excluded.postalCode') }} {{ exclude.zipcode }}</li>
                                <li>{{ $t('component.excluded.location') }} {{ exclude.location }}</li>
                            </ul>
                        </div>
                        <div class="px-2 py-2 border-t bg-gray-200 flex justify-between">
                            <div class="flex-col">
                                <span>
                                    <svg version="1.2" class="inline" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" overflow="visible" preserveAspectRatio="none" viewBox="0 0 24 24" width="18" height="18"><g><path xmlns:default="http://www.w3.org/2000/svg" d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z" style="fill: rgb(94, 94, 94);" vector-effect="non-scaling-stroke"/></g></svg>
                                </span>
                                <span class="font-bold text-sm">{{ $t('component.excluded.excludedat') }} {{ exclude.excluded_date }}</span>
                            </div>
                            <div class="flex-col">
                                <button class="font-bold text-sm border p-2 rounded bg-white shadow" type="button" @click="revoke(exclude.customer_id)">{{ $t('component.excluded.revoke') }}</button>
                            </div>
                        </div>
                    </CardBase>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LoadingSpinner from "@/components/LoadingSpinner";
    import {mapState} from "vuex";
    import CardBase from "../components/shared/CardBase";
    import CustomerService from "../services/customer.service";

    export default {
        name: "Exculuded",
        components: {CardBase, LoadingSpinner},
        computed: {
            ...mapState('customer', {
                excludes: 'excludes',
                loading: 'isLoading'
            })
        },
        async created() {
            this.$store.dispatch('customer/LOAD_EXCLUDES');
        },
        methods: {
            revoke(customer_id) {
                CustomerService.toggleExclude(customer_id)
                .then(() => {
                    this.$store.dispatch('customer/LOAD_EXCLUDES');
                })
                .catch(() => {

                });
            }
        }
    }
</script>

<style scoped>

</style>